module.exports = __webpack_public_path__ + "static/media/guidePage_openAccount.b12e8d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/guidePage_openAccount.png
// module id = 771
// module chunks = 0 1